import { FormErrorCodes } from "./form-constants"

const genericFieldValidator = (value) => {
  if (value !== null && value !== undefined) {
    return value.trim().length > 0
  }
  else {
    return false
  }
}

export const emailValidator = (email) => {
  if (email !== null && email !== undefined) {
    return email.includes("@") && email.includes(".")
  }
  else {
    return false
  }
}

export const formError = (errorCode, fieldName) => ({
  fieldName,
  errorCode
})

export const checkFormError = (formData) => {
  const fieldNames = Object.keys(formData)
  for (const fieldName of fieldNames) {
    const fieldData = formData[fieldName]

    if (fieldData.required && !genericFieldValidator(fieldData.value)) {
      return formError(
        FormErrorCodes.REQUIRED_FIELD_EMPTY, 
        fieldName
      )
    }
  }

  const email = formData["email"]
  if (email === undefined || email === null) {
    throw "Form doesn't have an email field. It is required for reply-to"
  }

  if (!emailValidator(email.value)) {
    return formError(
      FormErrorCodes.INVALID_EMAIL,
      "email"
    )
  }

  return null
}
